import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import UploadPage from "./pages/UploadPage";
import HistoryPage from "./pages/HistoryPage";
import LoginPage from "./pages/LoginPage";
import useAuth from "./hooks/useAuth";

function AuthenticatedLayout() {
  const user = useAuth();

  if (user === undefined) return null;

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "var(--ink-950)" }}>
      <Sidebar user={user} />
      <main style={{ flex: 1, overflowY: "auto", minWidth: 0 }}>
        <Routes>
          <Route path="/" element={<UploadPage />} />
          <Route path="/history" element={<HistoryPage />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={<AuthenticatedLayout />} />
      </Routes>
    </BrowserRouter>
  );
}
